import { action, makeObservable, observable } from "mobx";
import { enableStaticRendering } from "mobx-react-lite";
enableStaticRendering(typeof window === "undefined");
export class App {
    constructor() {
        this.rendererMode = "editor";
        makeObservable(this, {
            rendererMode: observable,
            setRendererMode: action,
        });
    }
    setRendererMode(mode) {
        this.rendererMode = mode;
    }
    hydrate(data) {
        this.rendererMode = data.rendererMode;
    }
}
